import { ModuleDefault } from '../default'

export class Read extends ModuleDefault {
    public getByMerchantId(merchantId: string): Promise<any> {
        return this.request.get(`${this.setup.urlBase}/customers/${merchantId}/merchant`)
    }
}
